var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
    },
    scopedSlots: _vm._u([
      {
        key: "cell(date)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.convertFromUtc(data.item.date, "MM/DD/YYYY HH:mm A")
                ) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(company)",
        fn: function (data) {
          return [
            _c(
              "h4",
              { staticClass: "mb-0" },
              [
                _c(
                  "b-link",
                  {
                    attrs: {
                      to: {
                        name: "admin-company",
                        params: { id: data.item.company.id },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(data.item.company.name) + "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "cell(type)",
        fn: function (data) {
          return [
            data.item.type === "order_fee"
              ? [_vm._v("Order Fee Payment")]
              : data.item.type === "pricing_plan"
              ? [_vm._v("Pricing Plan Payment")]
              : [_vm._v(_vm._s(data.item.type))],
          ]
        },
      },
      {
        key: "cell(amount)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.getFormattedPrice(data.item.total_payment)) +
                "\n    "
            ),
            data.item.total_refunded
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n      Refunded: " +
                      _vm._s(_vm.getFormattedPrice(data.item.total_refunded)) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(transaction)",
        fn: function (data) {
          return [
            data.item.transaction_id
              ? _c("div", [_vm._v("ID: " + _vm._s(data.item.transaction_id))])
              : _vm._e(),
            _vm._v(" "),
            data.item.auth_code
              ? _c("div", [_vm._v("Auth Code: " + _vm._s(data.item.auth_code))])
              : _vm._e(),
            _vm._v(" "),
            data.item.response_code
              ? _c("div", [
                  _vm._v("Response Code: " + _vm._s(data.item.response_code)),
                ])
              : _vm._e(),
            _vm._v(" "),
            data.item.transaction_status
              ? _c("div", [
                  _vm._v("\n      Status: "),
                  _c(
                    "span",
                    {
                      class: {
                        "text-danger":
                          data.item.transaction_status === "failed",
                      },
                    },
                    [_vm._v(_vm._s(data.item.transaction_status))]
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(payment_method)",
        fn: function (data) {
          return [
            data.item.payment_method === "auth_net"
              ? [_vm._v("Authorize.Net")]
              : [_vm._v(_vm._s(data.item.payment_method))],
            _vm._v(" "),
            data.item.card_brand
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(data.item.card_brand) +
                      " card ending in " +
                      _vm._s(data.item.card_ending) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            data.item.account_type
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(data.item.account_type) +
                      " account ending in " +
                      _vm._s(data.item.account_ending) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            data.item.routing_number
              ? _c("div", [
                  _vm._v(
                    "\n      Routing number: " +
                      _vm._s(data.item.routing_number) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            data.item.error
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(data.item.error)),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(orders)",
        fn: function (data) {
          return _vm._l(data.item.orders, function (orderId, key) {
            return _c(
              "span",
              { key: key, staticClass: "mr-2" },
              [
                _c(
                  "b-link",
                  {
                    attrs: {
                      to: { name: "admin-order", params: { id: orderId } },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(orderId) + "\n      ")]
                ),
              ],
              1
            )
          })
        },
      },
      {
        key: "cell(pricing_plans)",
        fn: function (data) {
          return _vm._l(data.item.pricing_plans, function (pPlan, key) {
            return _c(
              "span",
              { key: key, staticClass: "mr-2" },
              [
                _c(
                  "b-link",
                  {
                    attrs: {
                      to: {
                        name: "admin-pricing-plan-view",
                        params: { id: pPlan.id },
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(pPlan.name) + "\n      ")]
                ),
              ],
              1
            )
          })
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }